import { defineAsyncComponent } from 'vue';
import cCmsTwoColumns from '@/components/c-cms-two-columns.vue';
import cCmsWysiwyg from '@/components/c-cms-wysiwyg.vue';
import cHeader from '@/components/c-header.vue';
import cHeroBanner from '@/components/c-hero-banner.vue';
import cHeroMessage from '@/components/c-hero-message.vue';
import cSearchBanner from '@/components/c-search-banner.vue';
import cSlider1 from '@/components/c-slider-1.vue';
import cSlider2 from '@/components/c-slider-2.vue';
import cSliderItem4 from '@/components/c-slider-item-4.vue';
import cTabPanel from '@/components/c-tab-panel.vue';
import cTabs from '@/components/c-tabs.vue';
import cVerticalTabs from '@/components/c-vertical-tabs.vue';

// Import style only 'components'.
import.meta.glob('@/components/*.scss', { eager: true });

export default {
  install(app) {
    const websiteComponents = [
      cHeader,
      cTabs,
      cVerticalTabs,
      cTabPanel,
      cSlider1,
      cSlider2,
      cSliderItem4,
      cHeroMessage,
      cHeroBanner,
      cSearchBanner,
      cCmsWysiwyg,
      cCmsTwoColumns,
    ];

    websiteComponents.forEach((component) => {
      app.component(component.name, component);
    });

    // Lazy loaded components
    app.component(
      'c-password-reset',
      defineAsyncComponent(() => import('@/components/c-password-reset.vue')),
    );
    app.component(
      'c-gatekeeper-modal',
      defineAsyncComponent(() => import('@/components/c-gatekeeper-modal.vue')),
    );
    app.component(
      'c-welcome-modal',
      defineAsyncComponent(() => import('@/components/c-welcome-modal.vue')),
    );

    app.component(
      'c-labeled-control',
      defineAsyncComponent(() => import('@/components/c-labeled-control.vue')),
    );
    app.component(
      'c-marketing-consent-disclaimer',
      defineAsyncComponent(() => import('@/components/c-marketing-consent-disclaimer.vue')),
    );
    app.component(
      'c-cms-account-comparison',
      defineAsyncComponent(() => import('@/components/c-cms-account-comparison.vue')),
    );
    app.component(
      'c-cms-map',
      defineAsyncComponent(() => import('@/components/c-cms-map.vue')),
    );
    app.component(
      'c-product-comparison',
      defineAsyncComponent(() => import('@/components/c-product-comparison.vue')),
    );
    app.component(
      'c-cms-cementation-content',
      defineAsyncComponent(() => import('@/components/c-cms-cementation-content.vue')),
    );
    app.component(
      'c-cms-ips-certificate',
      defineAsyncComponent(() => import('@/components/c-cms-ips-certificate.vue')),
    );
    app.component(
      'c-cms-event-registration',
      defineAsyncComponent(() => import('@/components/c-cms-event-registration.vue')),
    );
    app.component(
      'c-product-tile',
      defineAsyncComponent(() => import('@/components/c-product-tile.vue')),
    );
    app.component(
      'c-cms-tabbed-card-comparison',
      defineAsyncComponent(() => import('@/components/c-cms-tabbed-card-comparison.vue')),
    );
    app.component(
      'c-workflow',
      defineAsyncComponent(() => import('@/areabricks/c-workflow.vue')),
    );
    app.component(
      'c-card',
      defineAsyncComponent(() => import('@/components/c-card.vue')),
    );
    app.component(
      'c-cms-anchored-navigation-bar',
      defineAsyncComponent(() => import('@/components/c-cms-anchored-navigation-bar.vue')),
    );
    app.component(
      'c-cms-banner',
      defineAsyncComponent(() => import('@/components/c-cms-banner.vue')),
    );
    app.component(
      'c-cms-button-group',
      defineAsyncComponent(() => import('@/components/c-cms-button-group.vue')),
    );
    app.component(
      'c-cms-container',
      defineAsyncComponent(() => import('@/components/c-cms-container.vue')),
    );
    app.component(
      'c-cms-content-tile',
      defineAsyncComponent(() => import('@/components/c-cms-content-tile.vue')),
    );
    app.component(
      'c-cms-image-blender',
      defineAsyncComponent(() => import('@/components/c-cms-image-blender.vue')),
    );
    app.component(
      'c-cms-image-gallery',
      defineAsyncComponent(() => import('@/components/c-cms-image-gallery.vue')),
    );
    app.component(
      'c-cms-mini-teaser',
      defineAsyncComponent(() => import('@/components/c-cms-mini-teaser.vue')),
    );
    app.component(
      'c-cms-teaser-list',
      defineAsyncComponent(() => import('@/components/c-cms-teaser-list.vue')),
    );
    app.component(
      'c-cms-video-timeline',
      defineAsyncComponent(() => import('@/components/c-cms-video-timeline.vue')),
    );
    app.component(
      'c-cms-video',
      defineAsyncComponent(() => import('@/components/c-cms-video.vue')),
    );
    app.component(
      'c-collapse-group',
      defineAsyncComponent(() => import('@/components/c-collapse-group.vue')),
    );
    app.component(
      'c-collapse',
      defineAsyncComponent(() => import('@/components/c-collapse.vue')),
    );
    app.component(
      'c-download-list',
      defineAsyncComponent(() => import('@/components/c-download-list.vue')),
    );

    // Lazy loaded profile
    app.component(
      'c-dashboard',
      defineAsyncComponent(() => import('@/components/c-dashboard.vue')),
    );
    app.component(
      'c-favourite-courses',
      defineAsyncComponent(() => import('@/components/c-favourite-courses.vue')),
    );
    app.component(
      'c-user-courses',
      defineAsyncComponent(() => import('@/components/c-user-courses.vue')),
    );
    app.component(
      'c-certificates-list',
      defineAsyncComponent(() => import('@/components/c-certificates-list.vue')),
    );

    // Lazy loaded eifu
    app.component(
      'c-eifu-header',
      defineAsyncComponent(() => import('@/components/eifu/c-eifu-header.vue')),
    );
    app.component(
      'c-eifu-footer',
      defineAsyncComponent(() => import('@/components/eifu/c-eifu-footer.vue')),
    );
    app.component(
      'c-eifu-footer-candulor',
      defineAsyncComponent(() => import('@/components/eifu/c-eifu-footer-candulor.vue')),
    );

    app.component(
      'c-breadcrumb',
      defineAsyncComponent(() => import('@/components/c-breadcrumb.vue')),
    );

    // Lazy loaded layouts
    app.component(
      'l-error',
      defineAsyncComponent(() => import('@/layouts/l-error.vue')),
    );
    app.component(
      'l-services',
      defineAsyncComponent(() => import('@/layouts/l-services.vue')),
    );
    app.component(
      'l-blog-list',
      defineAsyncComponent(() => import('@/layouts/l-blog-list.vue')),
    );
    app.component(
      'l-blog-detail',
      defineAsyncComponent(() => import('@/layouts/l-blog-detail.vue')),
    );
    app.component(
      'l-course-detail',
      defineAsyncComponent(() => import('@/layouts/l-course-detail.vue')),
    );
    app.component(
      'l-course-list',
      defineAsyncComponent(() => import('@/layouts/l-course-list.vue')),
    );
    app.component(
      'l-eifu-list',
      defineAsyncComponent(() => import('@/layouts/l-eifu-list.vue')),
    );
    app.component(
      'l-legal',
      defineAsyncComponent(() => import('@/layouts/l-legal.vue')),
    );
    app.component(
      'l-product-list',
      defineAsyncComponent(() => import('@/layouts/l-product-list.vue')),
    );
    app.component(
      'l-profile',
      defineAsyncComponent(() => import('@/layouts/l-profile.vue')),
    );
    app.component(
      'l-search-results',
      defineAsyncComponent(() => import('@/layouts/l-search-results.vue')),
    );
    app.component(
      'l-cms',
      defineAsyncComponent(() => import('@/layouts/l-cms.vue')),
    );

    // Lazy loaded IDS
    app.component(
      'c-ids-header',
      defineAsyncComponent(() => import('@/components/c-ids-header.vue')),
    );
    app.component(
      'c-ids-top-sections',
      defineAsyncComponent(() => import('@/components/c-ids-top-sections.vue')),
    );
    app.component(
      'c-ids-menu-tile',
      defineAsyncComponent(() => import('@/components/c-ids-menu-tile.vue')),
    );
    app.component(
      'l-ids-homepage',
      defineAsyncComponent(() => import('@/layouts/l-ids-homepage.vue')),
    );
    app.component(
      'l-ids-customer-zone',
      defineAsyncComponent(() => import('@/layouts/l-ids-customer-zone.vue')),
    );
    app.component(
      'l-ids-workflows',
      defineAsyncComponent(() => import('@/layouts/l-ids-workflows.vue')),
    );
    app.component(
      'l-ids-product-highlights',
      defineAsyncComponent(() => import('@/layouts/l-ids-product-highlights.vue')),
    );
    app.component(
      'l-ids-contact',
      defineAsyncComponent(() => import('@/layouts/l-ids-contact.vue')),
    );
    app.component(
      'l-ids-business-card-scanner',
      defineAsyncComponent(() => import('@/layouts/l-ids-business-card-scanner.vue')),
    );

    // Lazy loaded elements
    app.component(
      'e-button',
      defineAsyncComponent(() => import('@/elements/e-button.vue')),
    );
    app.component(
      'e-checkbox',
      defineAsyncComponent(() => import('@/elements/e-checkbox.vue')),
    );
    app.component(
      'e-icon-cta',
      defineAsyncComponent(() => import('@/elements/e-icon-cta.vue')),
    );
    app.component(
      'e-input',
      defineAsyncComponent(() => import('@/elements/e-input.vue')),
    );
    app.component(
      'e-radio',
      defineAsyncComponent(() => import('@/elements/e-radio.vue')),
    );
    app.component(
      'e-select',
      defineAsyncComponent(() => import('@/elements/e-select.vue')),
    );
    app.component(
      'c-select',
      defineAsyncComponent(() => import('@/components/c-select.vue')),
    );
    app.component(
      'e-textarea',
      defineAsyncComponent(() => import('@/elements/e-textarea.vue')),
    );
  },
};
